import Box from '@mui/material/Box';
import { MONO_FONT } from '@/theme';

/* Pill de filtro compacta (mono, uppercase) con estado activo. Fuente única
   del diseño: la usan el Glosario (GlosarioIndex) y el Blog y Actualidad (ContentFeed).
   Label típico: "Todos · 167". */
export default function FilterPill({ label, active, onClick }) {
  return (
    <Box
      component="button"
      onClick={onClick}
      sx={{
        px: '10px',
        py: '5px',
        fontFamily: MONO_FONT,
        fontSize: '10.5px',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        border: '1px solid',
        borderColor: active ? 'primary.main' : 'grey.200',
        color: active ? 'text.accent' : 'text.muted',
        borderRadius: '4px',
        cursor: 'pointer',
        background: 'none',
        fontWeight: active ? 600 : 400,
        transition: 'border-color 0.15s, color 0.15s',
        '&:hover': { borderColor: 'primary.light', color: 'text.accent' },
      }}
    >
      {label}
    </Box>
  );
}
